import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
import ProjectItem from './ProjectItem';
import './Projects.css';
import data from '../data.json';

function Projects() {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: '-80px' });

  return (
    <section id="projects" className="projects" ref={ref}>
      <div className="projects__inner">
        <div style={{ textAlign: 'center' }}>
          <motion.h2
            className="section-title"
            initial={{ opacity: 0, y: 20 }}
            animate={isInView ? { opacity: 1, y: 0 } : {}}
            transition={{ duration: 0.6 }}
            style={{ position: 'relative', left: 'auto', transform: 'none', display: 'inline-block' }}
          >
            ./Projects
          </motion.h2>
          <motion.div
            className="section-title-underline"
            initial={{ scaleX: 0 }}
            animate={isInView ? { scaleX: 1 } : {}}
            transition={{ duration: 0.6, delay: 0.3, type: 'spring', stiffness: 200, damping: 20 }}
            style={{ transformOrigin: 'center' }}
          />
        </div>

        <div className="projects__grid">
          {data.projects.map((project, i) => (
            <motion.div
              key={project.id}
              initial={{ opacity: 0, y: 40, rotate: -1.5 }}
              animate={isInView ? { opacity: 1, y: 0, rotate: 0 } : {}}
              transition={{ duration: 0.6, delay: Math.min(0.15 + i * 0.08, 0.8), ease: [0.4, 0, 0.2, 1] }}
            >
              <ProjectItem
                img_src={project.image}
                title={project.title}
                tags={project.tags}
                description={project.description}
                github_link={project.github}
              />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Projects;
